import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/Card/Card';
import DataTable from '../../components/DataTable/DataTable';
import { IColInfo } from '../../components/DataTable/Interfaces';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import DataService from "../../services/data.service";

const Countries: React.FC = () => {
    const [data, setData] = useState<any[]>();
    const { handleResult, handleException } = useNotifications();
    const { isAuthorizedFor } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        getTableData();
    }, []);

    function getTableData() {
        DataService.get<any[]>('api/v1/countries')
            .then(response => {
                setData(response);
            })
            .catch(e => { handleException(e); });
    }

    function add() {
        navigate('/plm/itemsetup/country/add', { state: { title: 'New country', fromMenu: false } });
    }

    function deleteRow(rowData) {
        DataService.delete('api/v1/countries/', rowData.id)
            .then(response => {
                handleResult(response);
                getTableData();
            })
            .catch(e => { handleException(e); });
    }

    const colInfos: IColInfo[] = [
        { title: 'ID', key: true, dataProp: 'id', dataType: 'number' },
        { title: 'Code', dataProp: 'code', sort: 'asc', filterInfo: { filterType: 'Textbox' } },
        { title: 'Name', dataProp: 'name', filterInfo: { filterType: 'Textbox' } },
        { title: 'Active', dataProp: 'isActive', dataType: 'bool', filterInfo: { filterType: 'CheckboxList' } },
    ];
    if (isAuthorizedFor(ApplicationFunctions.EditCountry)) {
        colInfos.push(
            {
                headerButtons: [{ text: "Add", icon: 'fa-plus-square', color: '#26A69A', onClick: add }],
                rowButtons: [{ text: "Delete", icon: 'fa-trash', color: '#F3565D', onClick: deleteRow }],
            });
    }

    return (
        <>
            <div className='main-content'>
                <Container fluid>
                    <Row>
                        <Col md={12}>
                            <Card title='Countries'
                                content={
                                    <DataTable
                                        name='dtCountries'
                                        tableData={data}
                                        colInfos={colInfos}
                                        navigateTitle='Country'
                                        navigateUrl='/plm/itemsetup/country/'
                                    />
                                }
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
export default Countries;